import { Dialog } from "@components";
import { Image, Pressable, ScrollView, Text } from "react-native";
import dayjs from 'dayjs'
import styles from "./Actualite.styles";
import MaterialCommunityIcons from "react-native-vector-icons/MaterialCommunityIcons";
import { stdCouleurBleu } from "@commonStyle";
import { ModalActualiteProps } from "./Actualite.types";

export default function ModalActualite({actualite, onOpenFile,  onClose}: ModalActualiteProps) {
  return (
    <Dialog
      visible={true}
      onClose={onClose}
      title={actualite?.libelle || 'Détails'}
    >
      {/* Date fixe dans le header, ne scroll pas */}
      <Text style={styles.dialogDateText} numberOfLines={1}>
        {dayjs(actualite?.date).format('DD/MM/YYYY')}
      </Text>

      {/* Contenu scrollable */}
      <ScrollView
        showsVerticalScrollIndicator={true}
        nestedScrollEnabled={true}        
        contentContainerStyle={{ paddingLeft: 8, paddingRight: 8, paddingBottom: 16, marginRight: 8 }}
      >
        {actualite?.img && (
          <Image 
            source={{ uri: actualite.img }} 
            style={styles.dialogImage} 
          />
        )}
        
        <Text style={styles.dialogContentText} numberOfLines={0}>
          {actualite?.contenu || actualite?.description}
        </Text>
        
        {actualite?.file && (
          <Pressable 
            onPress={onOpenFile}
            style={styles.dialogFileButton}
            testID='BT_DOWNLOAD_FILE'
          >
            <MaterialCommunityIcons 
              name={"file-download"} 
              color={stdCouleurBleu} 
              size={24} 
            />
            <Text style={styles.dialogFileButtonText}>
              Télécharger le fichier
            </Text>
          </Pressable>
        )}
      </ScrollView>
    </Dialog>
  )
}